/**
 * Build the card for display in the recent searches column
 * @param {} $rootScope 
 * @param {} recentSearchesFactory 
 * @returns {} 
 */
export default function (timetableService, recentSearchesFactory) {

    var recentSearchCardTemplate = `
        <li class="course-card">
          <a ng-click="get()" stop-event class="course-card-link">
            <h5 class="course-card-title" ng-bind="course.courseCode"></h5>
            <span class="course-card-name" ng-bind="course.description"></span>
            <button class="btn btn-link course-card-btn" title="Remove from recent searches" ng-click="remove()" stop-event>
                <i class="fal fa-xmark"></i>
            </button>
          </a>
        </li>`;

    return {
        scope: {
            course: '=',
            submitSearch: '&'
        },
        restrict: 'E',
        replace: true,
        template: recentSearchCardTemplate,
        link: function (scope) {

            scope.get = function () {
                timetableService.search(scope.course.courseCode, scope.course.termId);
            };

            scope.remove = function () {
                recentSearchesFactory.remove(scope.course);
            };
        }
    };
};